export default __webpack_public_path__ + "static/media/patty-paintbrush.c0a331e8.svg";